var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvertaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#trophy_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M15.832.5h2.5c.46 0 .833.373.833.833V5.5a3.333 3.333 0 0 1-3.333 3.333h-.06a5.83 5.83 0 0 1-4.94 4.94V15.5h.833a4.167 4.167 0 0 1 4.167 4.167c0 .46-.373.833-.833.833h-10a.833.833 0 0 1-.834-.833A4.167 4.167 0 0 1 8.332 15.5h.833v-1.726a5.83 5.83 0 0 1-4.94-4.94h-.06A3.333 3.333 0 0 1 .832 5.5V1.333c0-.46.373-.833.833-.833h14.167m1.178 6.179a1.67 1.67 0 0 1-1.178.488v-5h1.667V5.5c0 .442-.176.866-.488 1.179M4.166 2.167v5A1.667 1.667 0 0 1 2.5 5.5V2.167zm1.667 0V8a4.167 4.167 0 0 0 8.333 0V2.167zm.732 15.732a2.5 2.5 0 0 1 1.768-.732h3.333a2.5 2.5 0 0 1 2.357 1.666H5.975a2.5 2.5 0 0 1 .59-.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#trophy_svg__b)",
    d: "M15.832.5h2.5c.46 0 .833.373.833.833V5.5a3.333 3.333 0 0 1-3.333 3.333h-.06a5.83 5.83 0 0 1-4.94 4.94V15.5h.833a4.167 4.167 0 0 1 4.167 4.167c0 .46-.373.833-.833.833h-10a.833.833 0 0 1-.834-.833A4.167 4.167 0 0 1 8.332 15.5h.833v-1.726a5.83 5.83 0 0 1-4.94-4.94h-.06A3.333 3.333 0 0 1 .832 5.5V1.333c0-.46.373-.833.833-.833h14.167m1.178 6.179a1.67 1.67 0 0 1-1.178.488v-5h1.667V5.5c0 .442-.176.866-.488 1.179M4.166 2.167v5A1.667 1.667 0 0 1 2.5 5.5V2.167zm1.667 0V8a4.167 4.167 0 0 0 8.333 0V2.167zm.732 15.732a2.5 2.5 0 0 1 1.768-.732h3.333a2.5 2.5 0 0 1 2.357 1.666H5.975a2.5 2.5 0 0 1 .59-.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#trophy_svg__c)",
    d: "M15.832.5h2.5c.46 0 .833.373.833.833V5.5a3.333 3.333 0 0 1-3.333 3.333h-.06a5.83 5.83 0 0 1-4.94 4.94V15.5h.833a4.167 4.167 0 0 1 4.167 4.167c0 .46-.373.833-.833.833h-10a.833.833 0 0 1-.834-.833A4.167 4.167 0 0 1 8.332 15.5h.833v-1.726a5.83 5.83 0 0 1-4.94-4.94h-.06A3.333 3.333 0 0 1 .832 5.5V1.333c0-.46.373-.833.833-.833h14.167m1.178 6.179a1.67 1.67 0 0 1-1.178.488v-5h1.667V5.5c0 .442-.176.866-.488 1.179M4.166 2.167v5A1.667 1.667 0 0 1 2.5 5.5V2.167zm1.667 0V8a4.167 4.167 0 0 0 8.333 0V2.167zm.732 15.732a2.5 2.5 0 0 1 1.768-.732h3.333a2.5 2.5 0 0 1 2.357 1.666H5.975a2.5 2.5 0 0 1 .59-.934"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__b",
    x1: 9.999,
    x2: 9.999,
    y1: 0.5,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E71D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7659B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trophy_svg__c",
    x1: 9.999,
    x2: 9.999,
    y1: 0.5,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AABD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5674AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trophy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertaseIcon);
export default __webpack_public_path__ + "static/media/invertase-icon.5d1c083f2c927bc625f1d79ced2a377f.svg";
export { ForwardRef as ReactComponent };